var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 36,
    viewBox: "0 0 17 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Arrow_2",
    d: "M1.11681 27.1154C0.628274 27.6032 0.62765 28.3946 1.11542 28.8832C1.60319 29.3717 2.39465 29.3724 2.88319 28.8846L1.11681 27.1154ZM16.2705 15.001C16.2711 14.3106 15.7118 13.7505 15.0215 13.75L3.7715 13.7411C3.08114 13.7406 2.52106 14.2998 2.52051 14.9901C2.51997 15.6805 3.07917 16.2406 3.76953 16.2411L13.7695 16.249L13.7616 26.249C13.7611 26.9394 14.3203 27.4995 15.0107 27.5C15.701 27.5005 16.2611 26.9413 16.2616 26.251L16.2705 15.001ZM2.88319 28.8846L15.9037 15.8846L14.1373 14.1154L1.11681 27.1154L2.88319 28.8846Z",
    fill: "#7C7CFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBlue);
export default __webpack_public_path__ + "static/media/Arrow-blue.274663f36f936919c3287c5cd2bdb48a.svg";
export { ForwardRef as ReactComponent };